import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AuthContainer from './AuthContainer';
import Dashboard from './Dashboard';

const LandingPage: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Dashboard />;
  }

  return (
    <div className="landing-page">
      {/* Hero Section - Lighter Style */}
      <section className="hero-lighter">
        <div className="hero-content-lighter">
          <div className="hero-left">
            <h1 className="hero-title-lighter">
              ANALYZE ONCHAIN DATA WITH
              <br />
              AI-POWERED INSIGHTS
            </h1>
            <h1 className="hero-title-lighter mobile-title">
              ANALYZE ONCHAIN DATA
              <br />
              WITH AI INSIGHTS
            </h1>
            <p className="hero-description-lighter">
              A fully verifiable onchain analytics platform built with AI infrastructure, 
              providing real-time blockchain insights and predictive analytics.
            </p>
            <div className="hero-cta-lighter">
              <button className="btn-primary-lighter">EXPLORE FEATURES</button>
              <button className="btn-secondary-lighter" onClick={() => document.querySelector('.hero-auth-lighter')?.scrollIntoView({ behavior: 'smooth' })}>GET STARTED</button>
            </div>
          </div>
          <div className="hero-right">
            <div className="hero-auth-lighter">
              <AuthContainer />
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="cta-lighter">
        <div className="container">
          <div className="cta-content-lighter">
            <h2>Experience AI-driven onchain analytics like never before, with insights at the speed of blockchain.</h2>
            <div className="cta-buttons">
              <button className="btn-primary-lighter">GET STARTED</button>
              <button className="btn-secondary-lighter">EXPLORE FEATURES</button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>OnchainX</h3>
              <p>AI-Powered Onchain Data Analytics</p>
            </div>
            <div className="footer-section">
              <h4>Product</h4>
              <ul>
                <li><a href="#features">Features</a></li>
                <li><a href="#security">Security</a></li>
                <li><a href="#pricing">Pricing</a></li>
                <li><a href="#docs">Documentation</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About</a></li>
                <li><a href="#blog">Blog</a></li>
                <li><a href="#careers">Careers</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><a href="#help">Help Center</a></li>
                <li><a href="#status">Status</a></li>
                <li><a href="#privacy">Privacy</a></li>
                <li><a href="#terms">Terms</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 OnchainX. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
